import { CellRange, DataMap } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { CollectionView } from '@grapecity/wijmo';
import { Checkbox, Select, MenuItem } from '@mui/material';
import { CellType } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import TextComponent from 'components/Input/TextComponent';
import { useMaster } from 'context/MasterContext';
import { useRestApi } from 'context/RestApiContext';
import { MessageModal } from 'components/modal/MessageModal';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { KoujiTagComponent } from 'components/Input/KoujiTagComponent';
import { KoujiTagSelectComponent } from 'components/Input/KoujiTagSelectComponent';
import SelectComponent from 'components/Input/SelectComponent';
import ClientCardEditModal from 'views/ClientCards/ClientCardEditModal';
import AtenaPrintModal from 'views/ClientManage/AtenaPrintModal';
import ContactEmergencyOutlinedIcon from '@mui/icons-material/ContactEmergencyOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import './ClientManage.css';
import { toDate } from 'utils/dateUtils';
import * as wjGridXlsx from '@grapecity/wijmo.grid.xlsx';
import DownloadIcon from '@mui/icons-material/Download';

import { ClientRanks } from 'constants/constants';

const ClientManage = (props) => {
  const restApi = useRestApi();

  var clientRankMap = new DataMap([...ClientRanks, { key: 0, value: '' }], 'key', 'value');

  // グリッド
  const flexGrid = useRef();

  // スクロール位置
  const scrollPosition = useRef(0);

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 顧客一覧情報
  const [clients, setClients] = useState(new CollectionView([]));

  // 一覧の件数
  const [count, setCount] = useState(0);

  // 顧客検索条件
  const [searchCondition, setSearchCondition] = useState({
    NAME: '',
    DM_CHOFUKU: 0,
    COST_RANGE: ',',
    DM_START: '',
    DM_END: '',
    YEAR: '',
    MONTH: '',
    YEAR_END: '',
    MONTH_END: '',
    ANY_KOUJI_TAGS: false,
  });

  // 選択中のリスト
  const [selectedLists, setSelectedLists] = useState([4]); // 4:顧客リストを初期選択
  // 選択リストの変更処理
  const handleOnChangeLists = (value) => {
    setSelectedLists(value);
  };

  // 工事内容タグ
  const [koujiTags, setKoujiTags] = useState([]);
  // 工事タグの追加
  const addKoujiTag = (tagCodes) => {
    setKoujiTags([...koujiTags, ...tagCodes.filter((x) => !koujiTags.some((k) => k == x))]);
  };
  // 工事タグの削除
  const deleteKoujiTag = (tagCode) => {
    let _koujiTags = koujiTags.filter((x) => x != tagCode);
    // 工事タグが2件未満になった場合はいずれかに該当のチェックはOFFにする
    if (_koujiTags.length < 2) {
      setSearchCondition({ ...searchCondition, ANY_KOUJI_TAGS: false });
    }
    setKoujiTags(_koujiTags);
  };

  // いずれかに該当チェックボックスの変更処理
  const handleChangeAnyKoujiTags = (e) => {
    const isChecked = e.target.checked;
    let _searchCondition = { ...searchCondition, ANY_KOUJI_TAGS: isChecked };
    setSearchCondition(_searchCondition);
    searchClients(_searchCondition);
  };

  // マスタ情報
  const master = useMaster();

  // 顧客情報を画面用の表示データに変換
  const mapToClient = (x) => {
    return {
      CARD_ID: x.CARD_ID,
      CLIENT_CD: x.CLIENT_CD,
      DM_NO: x.DM_NO,
      LANK: x.LANK,
      NAME_1: x.NAME_1,
      TITLE: x.TITLE,
      KOUJI_MEI: x.KOUJI_MEI,
      ZIP: `〒${x.BUILD_POST_CODE}`,
      BUILD_CITY: x.BUILD_CITY,
      TEL: !x.TEL1 ? x.TEL2 : x.TEL1,
      ED_DATE: toDate(x.ED_DATE),
      SEIKYU_DATE: toDate(x.SEIKYU_DATE),
      ARCHIVE_FLG: x.ARCHIVE_FLG,
      PRINT_FLG: x.PRINT_FLG,
      MAIL: x.MAIL,
    };
  };

  // 検索処理
  const searchClients = (condition) => {
    restApi.post(
      '/api/client/list',
      { condition: condition, koujiTags: koujiTags, lists: selectedLists },
      (data) => {
        let sorted = [];

        // 一番古いデータを表示の場合
        if (condition.DM_CHOFUKU == 1) {
          let uniqueDMNos = new Set();
          // DM_NO
          sorted = data
            .map((x) => mapToClient(x))
            .sort((a, b) => {
              if (a.DM_NO == b.DM_NO) {
                const aValue = a.SEIKYU_DATE;
                const bValue = b.SEIKYU_DATE;
                if (!aValue) return 1; // aが日付変換できなければaを後ろに
                if (!bValue) return -1; // bが日付変換できなければbを後ろに
                return bValue < aValue ? 1 : -1;
              }

              return a.DM_NO > b.DM_NO ? -1 : 1;
            }) // DMナンバーの重複を排除
            .filter((client) => {
              if (!client.DM_NO || uniqueDMNos.has(client.DM_NO)) {
                return false;
              }
              uniqueDMNos.add(client.DM_NO);
              return true;
            })
            .sort((a, b) => {
              const aValue = a.SEIKYU_DATE;
              const bValue = b.SEIKYU_DATE;
              // aValue または bValue が日付に変換できなかった場合、先頭に移動する
              if (!aValue) return -1; // aが日付変換できなければaを前に
              if (!bValue) return 1; // bが日付変換できなければbを前に
              return bValue < aValue ? -1 : 1;
            });
          // 一番新しいデータを表示の場合
        } else if (condition.DM_CHOFUKU == 2) {
          let uniqueDMNos = new Set();
          // DM_NO
          sorted = data
            .map((x) => mapToClient(x))
            .sort((a, b) => {
              if (a.DM_NO == b.DM_NO) {
                const aValue = a.SEIKYU_DATE;
                const bValue = b.SEIKYU_DATE;
                if (!aValue) return 1; // aが日付変換できなければaを後ろに
                if (!bValue) return -1; // bが日付変換できなければbを後ろに
                return bValue > aValue ? 1 : -1;
              }

              return a.DM_NO > b.DM_NO ? -1 : 1;
            }) // DMナンバーの重複を排除
            .filter((client) => {
              if (!client.DM_NO || uniqueDMNos.has(client.DM_NO)) {
                return false;
              }
              uniqueDMNos.add(client.DM_NO);
              return true;
            })
            .sort((a, b) => {
              const aValue = a.ED_DATE;
              const bValue = b.ED_DATE;
              // aValue または bValue が日付に変換できなかった場合、先頭に移動する
              if (!aValue) return -1; // aが日付変換できなければaを前に
              if (!bValue) return 1; // bが日付変換できなければbを前に
              return bValue < aValue ? -1 : 1;
            });
        } else {
          // 請求日でソート
          sorted = data
            .map((x) => mapToClient(x))
            .sort((a, b) => {
              const aValue = a.SEIKYU_DATE;
              const bValue = b.SEIKYU_DATE;
              // aValue または bValue が日付に変換できなかった場合、先頭に移動する
              if (!aValue) return -1; // aが日付変換できなければaを前に
              if (!bValue) return 1; // bが日付変換できなければbを前に
              return bValue < aValue ? -1 : 1;
            });
        }
        const collectionView = new CollectionView(sorted);
        setClients(collectionView);
        setCount(sorted.length);
      }
    );
  };

  // 初期表示処理
  useEffect(() => {
    // 検索
    searchClients(searchCondition);
  }, [koujiTags, selectedLists]);

  // 対象の顧客番号の行を更新
  const updateRow = (targetClientCd) => {
    if (targetClientCd) {
      const index = clients.items.indexOf(
        clients.items.find((c) => c['CLIENT_CD'] == targetClientCd)
      );
      if (index >= 0) {
        restApi.get(`/api/client/${targetClientCd}`, (data) => {
          Object.assign(clients.items[index], mapToClient(data));
        });
      }
    }
  };

  // 検索ボタン
  const handleOnClickSearch = () => {
    searchClients(searchCondition);
  };

  // 編集処理
  const handleChange = (prop) => (target) => {
    const val = target?.value ?? target?.target.value;
    let _searchCondition = { ...searchCondition, [prop]: val };

    if (prop == 'YEAR' && !val) {
      _searchCondition = { ..._searchCondition, MONTH: '' };
    } else if (prop == 'YEAR_END' && !val) {
      _searchCondition = { ..._searchCondition, MONTH_END: '' };
    }

    // DMの重複、工事年月、費用範囲の場合は再検索
    if (['DM_CHOFUKU', 'YEAR', 'MONTH', 'YEAR_END', 'MONTH_END', 'COST_RANGE'].includes(prop)) {
      searchClients(_searchCondition);
    }

    setSearchCondition(_searchCondition);
  };

  // 宛名印刷
  const [atenaPringModalParam, setAtenaPringModalParam] = useState({});
  const handleOnClickAtenaPrint = () => {
    const grid = flexGrid.current.control; // フィルタを考慮した項目を取得
    let items = grid.collectionView.items;
    setAtenaPringModalParam({
      show: true,
      clients: items,
    });
  };

  // 案件に表示
  const hendleClickUnArchive = (item) => {
    setDialog({
      type: 'confirm',
      message: `カードを案件全般に表示します。よろしいですか？`,
      okCallBack: () => {
        restApi.post(`/api/cards/unarchive/${item.CARD_ID}`, { ARCHIVE_FLG: '1' }, (_) => {
          const target = clients.items.find((c) => c.CARD_ID == item.CARD_ID);
          if (target) {
            target.ARCHIVE_FLG = '0';
          }
        });
      },
    });
  };

  // カード編集モーダルのパラメタ
  const [cardEditModalparam, setCardEditModalparam] = useState({});
  // カード編集モーダルの呼び出し処理
  const callCardEditModal = (card) => {
    // スクロール位置を保持
    scrollPosition.current = flexGrid.current.control.scrollPosition;

    setCardEditModalparam({
      card: card,
    });
  };

  // フィルタの変更処理
  const filterApplied = (s, e) => {
    let grid = s.grid;
    setCount(grid?.collectionView?.items.length);
  };

  // Excelダウンロード
  const handleExcelDownload = () => {
    const grid = flexGrid.current.control; // FlexGridコンポーネントへの参照を取得
    const fileName = '顧客リスト.xlsx'; // ダウンロードするExcelファイルの名前

    // グリッドをExcel形式のオブジェクトに変換
    let workbook = wjGridXlsx.FlexGridXlsxConverter.save(grid, {
      includeCellStyles: true,
      includeColumns: function (column) {
        return column.binding; // 値なしは含めない（ボタンの項目）
      },
    });

    // 行の高さを固定（例えば20に統一）
    workbook.sheets.forEach((sheet) => {
      sheet.rows.forEach((row) => {
        row.height = 20; // 単位は Excel の標準行高さ単位
      });
    });

    // 保存
    workbook.save(fileName);
  };

  return (
    <>
      <Card className="m-0 pl-3 pt-1  table-container">
        <Row>
          <Col className="pr-1" md="2">
            <label>DMナンバー</label>
            <div className="mt-1" style={{ display: 'flex', alignItems: 'center' }}>
              <TextComponent
                type="text"
                value={searchCondition.DM_START}
                onChange={handleChange('DM_START')}
              />
              &nbsp;～&nbsp;
              <TextComponent
                type="text"
                value={searchCondition.DM_END}
                onChange={handleChange('DM_END')}
              />
            </div>
          </Col>
          <Col className="pr-1" md="3">
            <label>施主名</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <TextComponent
                className="client_text"
                placeholder="部分一致で検索します"
                type="text"
                value={searchCondition.NAME}
                onChange={handleChange('NAME')}
              ></TextComponent>
              <Button
                style={{ width: '48px', height: '32px', marginTop: '5px' }}
                variant="success"
                className="btn-fill m-2"
                size="sm"
                onClick={handleOnClickSearch}
              >
                検索
              </Button>
              <Button
                style={{ width: '94px', height: '32px', marginTop: '5px' }}
                variant="primary"
                className="btn-fill m-2"
                size="sm"
                onClick={handleOnClickAtenaPrint}
              >
                <PrintOutlinedIcon className="mr-1" style={{ fontSize: 18 }} />
                宛名印刷
              </Button>
            </div>
          </Col>
          <Col md="7">
            <div style={{ display: 'flex' }}>
              <div style={{ display: 'flex', width: 420 }}>
                <div className="ml-3 pr-1">
                  <label>工事年月</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectComponent value={searchCondition.YEAR} onChange={handleChange('YEAR')}>
                      <option key={0} value={''}>
                        {'　'}
                      </option>

                      {Array.from(
                        { length: new Date().getFullYear() - 2018 + 1 },
                        (_, i) => 2018 + i
                      )
                        .reverse()
                        .map((i) => (
                          <option key={i} value={i}>
                            {i}年
                          </option>
                        ))}
                    </SelectComponent>
                  </div>
                </div>
                {searchCondition.YEAR && (
                  <>
                    <div className="ml-1 pr-1">
                      <label>　</label>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SelectComponent
                          value={searchCondition.MONTH}
                          onChange={handleChange('MONTH')}
                        >
                          <option key={0} value={''}>
                            {'　'}
                          </option>

                          {Array.from({ length: 12 }, (_, i) => i + 1).map((i) => (
                            <option key={i} value={i}>
                              {i}月
                            </option>
                          ))}
                        </SelectComponent>
                      </div>
                    </div>
                    <div className="ml-1 pr-1">
                      <label className="ml-3">　</label>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        ～
                        <SelectComponent
                          value={searchCondition.YEAR_END}
                          onChange={handleChange('YEAR_END')}
                        >
                          <option key={0} value={''}>
                            {'　'}
                          </option>

                          {Array.from(
                            { length: new Date().getFullYear() - 2018 + 1 },
                            (_, i) => 2018 + i
                          )
                            .reverse()
                            .map((i) => (
                              <option key={i} value={i}>
                                {i}年
                              </option>
                            ))}
                        </SelectComponent>
                      </div>
                    </div>
                    {searchCondition.YEAR_END && (
                      <div className="ml-1 pr-1">
                        <label>　</label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <SelectComponent
                            className="ml-0"
                            value={searchCondition.MONTH_END}
                            onChange={handleChange('MONTH_END')}
                          >
                            <option key={0} value={''}>
                              {'　'}
                            </option>

                            {Array.from({ length: 12 }, (_, i) => i + 1).map((i) => (
                              <option key={i} value={i}>
                                {i}月
                              </option>
                            ))}
                          </SelectComponent>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="ml-2">
                <label>DMナンバーの重複</label>
                <SelectComponent
                  value={searchCondition.DM_CHOFUKU}
                  onChange={handleChange('DM_CHOFUKU')}
                >
                  <option value={0}>すべて表示</option>
                  <option value={2}>一番新しいデータを表示</option>
                  <option value={1}>一番古いデータを表示</option>
                </SelectComponent>
              </div>
              <div className="ml-2">
                <label>費用</label>
                <SelectComponent
                  value={searchCondition.COST_RANGE}
                  onChange={handleChange('COST_RANGE')}
                >
                  <option value={','}>すべて表示</option>
                  <option value={',50'}>50以下</option>
                  <option value={'50,100'}>50～100</option>
                  <option value={'100,150'}>100～150</option>
                  <option value={'150,200'}>150～200</option>
                  <option value={'200,250'}>200～250</option>
                  <option value={'250,350'}>250～350</option>
                  <option value={'350,500'}>350～500</option>
                  <option value={'500,700'}>500～700</option>
                  <option value={'700,1000'}>700～1000</option>
                  <option value={'1000,'}>1000以上</option>
                </SelectComponent>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="2">
            <label>リスト</label>
            <Select
              fullWidth
              multiple
              displayEmpty
              style={{ height: '38px' }}
              className="ml-2"
              variant="standard"
              value={selectedLists}
              renderValue={(x) => {
                if (x.length === 0) {
                  return (
                    <em className="pl-2" style={{ color: '#ababab' }}>
                      リストを選択
                    </em>
                  );
                }
                return (
                  <div className="pl-1">
                    {master.ankenListNames
                      .filter((x) => selectedLists.includes(x.id))
                      .map((x) => x.name)
                      .join('、')}
                  </div>
                );
              }}
              onChange={(e) => {
                handleOnChangeLists(e.target.value);
              }}
            >
              <MenuItem disabled value="">
                <em>リストを選択</em>
              </MenuItem>
              {master.ankenListNames.map((x) => (
                <MenuItem key={x.id} value={x.id} className="m-0 p-0">
                  <Checkbox checked={selectedLists.includes(x.id)} className="m-0 ml-2 p-1" />
                  <h5 className="m-0 p-0">{x.name}</h5>
                </MenuItem>
              ))}
            </Select>
          </Col>
          <Col md="10">
            <label>タグ</label>
            <div style={{ display: 'flex' }}>
              <KoujiTagSelectComponent
                labels={master.label}
                tagTypes={master.tagTypes}
                callAddTag={addKoujiTag}
              />
              {/** 2件以上の場合にいずれかに該当を選択可能 */}
              {koujiTags.length >= 2 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label
                    className="mt-1 ml-3"
                    style={{ fontSize: '14pt', color: 'black', whiteSpace: 'nowrap' }}
                  >
                    <input
                      className="mr-3"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={searchCondition.ANY_KOUJI_TAGS}
                      onChange={handleChangeAnyKoujiTags}
                    ></input>
                    いずれかに該当
                  </label>
                </div>
              )}
              <div className="ml-2 mt-1">
                {koujiTags.map((x) => (
                  <KoujiTagComponent labels={master.label} tagCode={x} onDelete={deleteKoujiTag} />
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>件数：{count}件</div>
          <Button
            variant="success"
            className="btn-fill p-0 pl-1 pr-1 mr-3"
            size="sm"
            onClick={handleExcelDownload}
          >
            <DownloadIcon className="mr-1" style={{ fontSize: 18 }} />
            ダウンロード
          </Button>
        </div>
        <Row>
          <Col>
            <div className="table-scroll" style={{ height: 'calc(100vh - 272px)' }}>
              <FlexGrid
                ref={flexGrid}
                isReadOnly={true}
                itemsSource={clients}
                selectionMode={'Row'}
                headersVisibility={'Column'}
                style={{ height: '100%' }}
                onDoubleClick={(e) => {
                  const grid = flexGrid.current.control;
                  const ht = grid.hitTest(e);
                  if (ht.cellType === CellType.Cell) {
                    const item = grid.rows[ht.row].dataItem;
                    callCardEditModal(item); // カードダイアログを開く処理
                  }
                }}
                copying={(s, e) => {
                  // セル単位でコピーする
                  const selection = s.selection;
                  const selectedCellContent = s.getCellData(selection.row, selection.col, true);
                  // クリップボードにコピーされる内容を上書き
                  e.cancel = true;
                  navigator.clipboard.writeText(selectedCellContent);
                }}
              >
                <FlexGridFilter filterApplied={filterApplied} />
                <FlexGridColumn header="" binding="" isReadOnly={true} width={42}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) => (
                      <span>
                        <Button
                          className="btn-fill detail_button"
                          variant="secondary"
                          title="カード表示"
                          onClick={() => callCardEditModal(cell.item)}
                        >
                          <ContactEmergencyOutlinedIcon />
                        </Button>
                      </span>
                    )}
                  />
                </FlexGridColumn>
                <FlexGridColumn
                  binding="DM_NO"
                  header="DM"
                  width={48}
                  cssClass="item_center"
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="LANK"
                  dataMap={clientRankMap}
                  header="ランク"
                  width={64}
                  cssClass="item_center"
                ></FlexGridColumn>
                <FlexGridColumn binding="NAME_1" header="施主名１" width={120}></FlexGridColumn>
                <FlexGridColumn binding="TITLE" header="カード" width={220}></FlexGridColumn>
                <FlexGridColumn binding="KOUJI_MEI" header="工事名" width={240}></FlexGridColumn>
                <FlexGridColumn binding="ZIP" header="郵便番号" width={82}></FlexGridColumn>
                <FlexGridColumn
                  binding="BUILD_CITY"
                  minWidth={220}
                  header="住所"
                  width={'*'}
                ></FlexGridColumn>
                <FlexGridColumn binding="TEL" header="電話番号" width={150}></FlexGridColumn>
                <FlexGridColumn binding="ED_DATE" header="工事完工日" width={110}></FlexGridColumn>
                <FlexGridColumn binding="SEIKYU_DATE" header="請求日" width={110}></FlexGridColumn>
                <FlexGridColumn header="案件" binding="" isReadOnly={true} width={108}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) =>
                      cell.item.ARCHIVE_FLG == '1' ? (
                        <Button
                          className="btn-fill archive_button"
                          variant="warning"
                          onClick={() => {
                            hendleClickUnArchive(cell.item);
                          }}
                        >
                          <Inventory2OutlinedIcon />
                          カード非表示
                        </Button>
                      ) : (
                        <></>
                      )
                    }
                  />
                </FlexGridColumn>
              </FlexGrid>
            </div>
          </Col>
        </Row>
      </Card>
      {/** カード編集モーダル画面 */}
      <ClientCardEditModal
        params={cardEditModalparam}
        loadCards={() => {
          updateRow(cardEditModalparam.card.CLIENT_CD);
        }}
      />
      {/* メッセージダイアログ */}
      <MessageModal dialog={dialog}></MessageModal>
      {/** 宛名印刷モーダル画面 */}
      <AtenaPrintModal params={atenaPringModalParam} />
    </>
  );
};

export default ClientManage;
